<textarea class='edit-control' [(ngModel)]="edtorContent"></textarea>
